<template>
  <div class="container">
    <h1 class="py-4">ダウンロード</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-12"  v-if="this.targetData!=='userLog' && this.targetData!=='userList'">
          <label for="l-targetData">出力対象</label>
          <select id="l-targetData" class="form-control" v-model="targetData" @change="init">
            <option disabled value="" >選択してください</option>
            <option v-for="(value , index) in this.outputInfo" :key="index" :value="value.name">
              {{ value.label }}
            </option> 
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="l-monthPicker">出力年月</label>
          <Datepicker id="l-monthPicker" class="picker" :bootstrap-styling="true" v-model="monthPicker" :format="monthPickerFormat"
            :maximum-view="'month'" :minimum-view="'month'" :typeable="true" :language="ja" @input="init" placeholder="YYYY-MM" />
        </div>
        <div class="form-group col-md-6">
          <label for="l-datePicker">出力年月日</label>
          <Datepicker id="l-datePicker" class="picker" :bootstrap-styling="true" v-model="datePicker" :format="datePickerFormat" :typeable="true" :language="ja" @input="init" placeholder="YYYY-MM-DD" />
        </div>
          <div class="form-group col-md-6" >
            <label for="l-pid">PID</label><br>
            <input v-model="pid" placeholder="PID" class="input-boot">
          </div>
          <div class="form-group col-md-6" v-if="!this.eq(this.targetData , 'userList')">
            <label for="l-redirect">リダイレクト先</label><br>
            <select v-model="redirectId" class="input-boot">
              <option value="">選択してください</option>
              <option v-for="option in this.redirects" :value="option.value" :key="option.value">
                {{ option.name }} - {{ option.value}}
              </option>
            </select>
          </div>
        </div>
      <div class="text-right">
        <vue-json-to-csv v-if="this.jsonData.length" 
           :json-data="this.jsonData" 
           :labels="this.labels"
           :csv-title="this.fileName">
          <button class="btn btn-primary mr-4">ダウンロード</button>
        </vue-json-to-csv>
        <button class="btn btn-primary" @click="output">データ出力</button>
      </div>
    </div>
    <div v-if="show" :key="key">
      <userInfo v-if="this.eq(this.targetData , 'user')" 
        :firstDate="firstDate"
        :lastDate="lastDate"
        @bind-event="setJsonData"
      />
      <jobsInfo v-if="this.eq(this.targetData , 'jobs')" 
        :firstDate="firstDate"
        :lastDate="lastDate"
        @bind-event="setJsonData"
      />
      <jobApplyInfo v-if="this.eq(this.targetData , 'job_apply')" 
        :firstDate="firstDate"
        :lastDate="lastDate"
        @bind-event="setJsonData"
      />
      <jobViewInfo v-if="this.eq(this.targetData , 'job_detail_view_histories')" 
        :firstDate="firstDate"
        :lastDate="lastDate"
        @bind-event="setJsonData"
      />
      <serviceLinkInfo v-if="this.eq(this.targetData , 'service_link_click_histories')" 
        :firstDate="firstDate"
        :lastDate="lastDate"
        @bind-event="setJsonData"
      />
      <userLog v-if="this.eq(this.targetData , 'userLog')" 
        :firstDate="firstDate"
        :lastDate="lastDate"
        :pid="pid"
        :redirectId="redirectId"
        @bind-event="setJsonData"
      />
      <userListInfo v-if="this.eq(this.targetData , 'userList')" 
        :firstDate="firstDate"
        :lastDate="lastDate"
        :pid="pid"
        :redirectId="redirectId"
        @bind-event="setJsonData"
      />
    </div>
  </div>
</template>

<script>
//import Vue from 'vue'
import master from '@/constants/MasterEnum'
import utils from '@/utils/Utils'
import userLog from '@/components/UserLogInfo'
import userInfo from '@/components/UserInfo'
import userListInfo from '@/components/UserListInfo'
import jobsInfo from '@/components/JobsInfo'
import jobApplyInfo from '@/components/JobApplyInfo'
import jobViewInfo from '@/components/JobDetailViewHistoryInfo'
import serviceLinkInfo from '@/components/ServiceLinkClickHistory'
import VueJsonToCsv from 'vue-json-to-csv'
import Datepicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale'


export default {
  name: 'outputData',
  mixins : [
    utils,
    master,
  ],
  data () {
    return {
      pid:"",
      redirectId:"",
      jsonData : [],
      fileName : "",
      labels : "",
      targetData: this.$route.query.target,
      monthPickerFormat: 'yyyy-MM',
      datePickerFormat: 'yyyy-MM-dd',
      monthPicker :"",
      datePicker :"",
      ja:ja,
      show : false,
      key: 0,
    }
  },
  components: {
    Datepicker,
    VueJsonToCsv,
    userListInfo,
    userInfo,
    userLog,
    jobsInfo,
    jobApplyInfo,
    jobViewInfo,
    serviceLinkInfo,
  },
  computed: {
    firstDate : function() {
      // 日付が指定されているならが優先
      if (this.isNotEmpty(this.datePicker)) {
        return this.getFirstOfDay(this.datePicker);
      }
      return this.getFirstDate(new Date(this.monthPicker));
    },
    lastDate : function() {
      // 日付が指定されているならが優先
      if (this.isNotEmpty(this.datePicker)) {
        return this.getLastOfDay(this.datePicker);
      }
      return this.getLastDate(new Date(this.monthPicker));
    },
  },
  methods: {
    init() {
      this.show = false;
      this.jsonData = [];
      this.key = this.key ? 0 : 1;
    },
    setJsonData(data , fileName , labels) {
      this.jsonData = data;
      this.fileName = fileName;
      this.labels = labels;
    },
    output() {
      this.init()
      if (this.isEmpty(this.targetData)) {
        this.$toasted.error("出力する情報を選択してください")
        return
      }
      if (this.isEmpty(this.monthPicker) && this.isEmpty(this.datePicker)) {
        this.$toasted.error("出力年月または年月日を指定してください")
        return
      }
      this.show = true
    },
/*     search(){
      this.bus.$emit('search',{pid:this.pid,redirectId:this.redirectId});
    } */
  }
}
</script>
